import { QUANTUM_QS } from '../../../../flags';
import { Tutorial } from './Tutorial';
import { Tutorial as TutorialOld } from './Tutorial.old';
var TutorialComponent = QUANTUM_QS ? Tutorial : TutorialOld;
export default TutorialComponent;
